import React from 'react';
import Divider from '@mui/material/Divider';

const HistoryTrackDivider: React.FC = () => (
  <Divider sx={{ backgroundColor: 'white', opacity: 0.5 }} />
);

export default HistoryTrackDivider;
